var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnChatbotGrayPro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10725_78362)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10725_78362)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 25,
    fill: "#D5D5D5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.4109 12.5254C29.9018 12.5255 31.1101 13.7346 31.1101 15.2256C31.1099 16.3642 30.4043 17.3358 29.407 17.7324V19.0273H35.739C39.1335 19.0273 41.6277 22.189 41.6277 25.7461V33.0244C41.6276 36.5804 39.1334 39.7412 35.739 39.7412H28.615L21.4753 42.8643C21.1662 42.9994 20.8095 42.9689 20.5271 42.7842C20.2448 42.5994 20.075 42.2847 20.075 41.9473V39.6455C17.2019 39.0966 15.1863 36.221 15.1863 33.0244V25.7441C15.1865 22.1896 17.6801 19.0296 21.074 19.0293L27.407 19.0273V17.7295C26.4136 17.331 25.7109 16.3614 25.7107 15.2256C25.7107 13.7346 26.9199 12.5254 28.4109 12.5254ZM21.075 21.0293C19.0678 21.0293 17.1865 22.9886 17.1863 25.7441V33.0244C17.1863 35.7815 19.0679 37.7412 21.075 37.7412C21.627 37.7414 22.075 38.1891 22.075 38.7412V40.418L28.0066 37.8252L28.1023 37.7881C28.2005 37.7567 28.3035 37.7412 28.407 37.7412H35.739C37.7461 37.7412 39.6276 35.7815 39.6277 33.0244V25.7461C39.6277 22.9876 37.746 21.0273 35.739 21.0273L21.075 21.0293ZM25.2214 32.9131C25.5523 32.4712 26.1797 32.3814 26.6218 32.7119C27.1369 33.0973 27.7628 33.3065 28.406 33.3076C29.0498 33.3068 29.6767 33.0976 30.1921 32.7119C30.6341 32.3815 31.2606 32.4715 31.5916 32.9131C31.9224 33.3552 31.8324 33.9825 31.3904 34.3135C30.5296 34.9576 29.4831 35.3064 28.408 35.3076H28.405C27.33 35.3063 26.2833 34.9576 25.4226 34.3135C24.9809 33.9825 24.8907 33.3551 25.2214 32.9131ZM23.8162 24.251C24.806 24.2512 25.6082 25.054 25.6082 26.0439V28.0781C25.6082 29.0681 24.806 29.8708 23.8162 29.8711C22.8261 29.8711 22.0232 29.0682 22.0232 28.0781V26.0439C22.0232 25.0538 22.8261 24.251 23.8162 24.251ZM32.9978 24.251C33.9879 24.251 34.7908 25.0538 34.7908 26.0439V28.0781C34.7908 29.0682 33.9879 29.8711 32.9978 29.8711C32.0077 29.8711 31.2048 29.0682 31.2048 28.0781V26.0439C31.2048 25.0538 32.0077 24.251 32.9978 24.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2391 40.0545C49.2389 42.5771 47.1935 44.622 44.6709 44.622H32.9752C30.4526 44.622 28.4072 42.5771 28.407 40.0545C28.407 37.5318 30.4524 35.4863 32.9752 35.4863H44.6709C47.1936 35.4863 49.2391 37.5318 49.2391 40.0545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6707 35.4863C47.1934 35.4863 49.239 37.532 49.239 40.0547C49.2388 42.5772 47.1932 44.6221 44.6707 44.6221H32.9753C30.4527 44.6221 28.4072 42.5772 28.407 40.0547C28.407 37.532 30.4526 35.4863 32.9753 35.4863H44.6707ZM42.9841 37.7783C41.679 37.7783 40.8612 38.6531 40.8611 40.0557C40.8611 41.4554 41.6789 42.3281 42.9841 42.3281C44.286 42.3279 45.1062 41.4553 45.1062 40.0557C45.1061 38.6532 44.2859 37.7785 42.9841 37.7783ZM37.4578 37.8535C37.1681 37.8536 36.9978 38.0312 36.9978 38.333V41.8398C36.9979 42.1415 37.1713 42.3183 37.4578 42.3184C37.7474 42.3184 37.9186 42.1415 37.9187 41.8398V40.6445H38.7019L39.4343 41.9707C39.5837 42.2389 39.6845 42.3184 39.9041 42.3184C40.1722 42.3182 40.3669 42.1413 40.3669 41.8975C40.3669 41.7907 40.3455 41.7112 40.2693 41.5801L39.6355 40.4824C40.1202 40.275 40.3913 39.8055 40.3914 39.2568C40.3914 38.3877 39.812 37.8535 38.7996 37.8535H37.4578ZM33.5974 37.8535C33.3077 37.8535 33.1365 38.0311 33.1365 38.333V41.833C33.1365 42.1349 33.3077 42.3125 33.5974 42.3125C33.887 42.3124 34.0574 42.1348 34.0574 41.833V40.8662H34.8806C35.8076 40.8662 36.4518 40.2629 36.4519 39.3604C36.4519 38.4546 35.8292 37.8535 34.9265 37.8535H33.5974ZM42.9841 38.5469C43.7035 38.5471 44.1637 39.132 44.1638 40.0557C44.1638 40.9764 43.7036 41.5593 42.9841 41.5596C42.2614 41.5596 41.8005 40.9766 41.8005 40.0557C41.8007 39.1319 42.2645 38.5469 42.9841 38.5469ZM34.6824 38.583C35.2099 38.583 35.5154 38.8632 35.5154 39.3633C35.5154 39.8664 35.207 40.1475 34.6794 40.1475H34.0574V38.583H34.6824ZM38.7019 38.5732C39.1592 38.5732 39.4459 38.8477 39.446 39.2744C39.446 39.7104 39.1749 39.9764 38.7117 39.9766H37.9187V38.5732H38.7019Z",
    fill: "#F59D24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10725_78362",
    x: 2.5,
    y: 2.5,
    width: 59,
    height: 59,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10725_78362"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10725_78362",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10725_78362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnChatbotGrayPro);
export default __webpack_public_path__ + "static/media/icn_chatbot_gray_pro.aff7314c28fda1b99fefaf41eda3d649.svg";
export { ForwardRef as ReactComponent };